acceptAll: Accept all
acceptSelected: Accept selected
close: Close
consentModal:
  description: We use cookies to improve user-friendliness. We asks you to accept so-called cookies for the purposes of the performance of its website www.gontermann-peipers.de and its subpages. Here you can view and adjust which information we collect with the help of these cookies. To learn more, please read our privacy policy.
  privacyPolicy:
    name: Privacy policy
    text: To learn more, please read our {privacyPolicy}.
  title: Services we would like to use
consentNotice:
  changeDescription: There were changes since your last visit, please renew your consent.
  description: In order to design our website optimally for you and to be able to improve it continuously, we use cookies. You can decide for yourself via "Customize consent" which optional cookies should be set when using the website.
  imprint:
    name: Imprint
  learnMore: Adapt consent
  privacyPolicy:
    name: Privacy policy
  testing: Testing mode!
contextualConsent:
  acceptAlways: Always
  acceptOnce: 'Only now'
  description: Do you want to load external content supplied by {title}?
decline: I decline
ok: That's ok
poweredBy: Realized with Klaro!
privacyPolicy:
  name: privacy policy
  text: To learn more, please read our {privacyPolicy}.
purposeItem:
  service: service
  services: services
purposes:
  necessary:
    title: Technically necessary
    description: Necessary cookies help us to make this website usable by enabling basic functions such as page navigation and access to secure areas of the website. The website can only function in a limited way without these cookies.
  services:
    title: Service provision
    description: 
  social:
    title: Embedding social networks
    description: 
  analytics:
    title: Visitor statistics
    description: Statistics cookies help us to understand how visitors interact with our pages and when and how often which pages are accessed. Information is collected anonymously for this purpose.
save: Save
service:
  disableAll:
    description: Use this switch to enable or disable all services.
    title: Enable or disable all services
  optOut:
    description: This services is loaded by default (but you can opt out)
    title: (opt-out)
  purpose: purpose
  purposes: purposes
  required:
    description: This services is always required
    title: (always required)
geodata:
  title:  Maps of the City of Osnabrück
googleMaps:
  title: Maps from GoogleMaps
